import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import localStyles from './style.module.css'
import { useAssetLimitsLogic } from '~hooks/useAssetLimitsLogic'
import { useKycUserInfo, useUserInfo } from '~api'

function Preloader() {
    useKycUserInfo()
    useAssetLimitsLogic()
    useUserInfo()

    return (
        <div className={localStyles.wrap}>
            <div className={localStyles.segmentedControl}>
                <Loader borderRadius="s" width="100%" height={32} />
                <Loader borderRadius="s" width="100%" height={32} />
                <Loader borderRadius="s" width="100%" height={32} />
            </div>

            <div className={localStyles.container}>
                <div className={localStyles.blockContainer} data-pointer="buy_widget_preloader" />
                <div className={localStyles.switcher} />
                <div className={localStyles.blockContainer} data-pointer="buy_widget_preloader" />
            </div>

            <div className={localStyles.text}>
                <Loader width="85%" height={17} />
            </div>

            <div className={localStyles.infoBar} />
            <div className={localStyles.infoBar} />

            <div className={localStyles.textCentered}>
                <Loader width="90%" height={17} />
            </div>
        </div>
    )
}

export default Preloader
